import { useQuery, gql } from "@apollo/client";
import type { QueryHookOptions } from "@apollo/client";

const TEAM_MEMBERS_QUERY = gql`
  query TeamMembers {
    teamMembers {
      id
      slug
      avatarMedium
      name
      position
      phone
    }
  }
`;

interface TeamMemberData {
  teamMembers: {
    slug: string;
    avatarMedium: string | null;
    name: string;
    position: string | null;
    phone: string | null;
  }[];
}

const useTeamMembersQuery = (options?: QueryHookOptions<TeamMemberData>) => {
  return useQuery<TeamMemberData>(TEAM_MEMBERS_QUERY, options);
};

export { useTeamMembersQuery, TEAM_MEMBERS_QUERY };
